import React from 'react';
import PropTypes from 'prop-types';

export const CustomComponent = ({
  Renderer, renderProps, children, ...dynamicProps
}) => <Renderer {...renderProps} {...dynamicProps}>{children}</Renderer>;

CustomComponent.propTypes = {
  Renderer: PropTypes.elementType.isRequired,
  renderProps: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

CustomComponent.defaultProps = {
  renderProps: null,
  children: null,
};
